import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PeopleIcon from '@mui/icons-material/People';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import ChatIcon from '@mui/icons-material/Chat';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SettingsIcon from '@mui/icons-material/Settings';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import ConnectWithoutContactIcon from '@mui/icons-material/ConnectWithoutContact';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import LinkIcon from '@mui/icons-material/Link';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import QueueIcon from '@mui/icons-material/Queue';
import AssignmentIcon from '@mui/icons-material/Assignment';
import EventNoteIcon from '@mui/icons-material/EventNote';
import GroupsIcon from '@mui/icons-material/Groups';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import FeedbackIcon from '@mui/icons-material/Feedback';
import VideocamIcon from '@mui/icons-material/Videocam';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import ScienceIcon from '@mui/icons-material/Science';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ScheduleIcon from '@mui/icons-material/Schedule';
import UsersIcon from '../icons/Users';

const ICONS = {
  home: HomeIcon,
  person: PersonIcon,
  shoppingCart: ShoppingCartIcon,
  people: PeopleIcon,
  medical: MedicalInformationIcon,
  chat: ChatIcon,
  queryStats: QueryStatsIcon,
  settings: SettingsIcon,
  eventBusy: EventBusyIcon,
  creditCard: CreditCardIcon,
  connect: ConnectWithoutContactIcon,
  hospital: LocalHospitalIcon,
  warning: WarningAmberIcon,
  link: LinkIcon,
  menuBook: MenuBookIcon,
  queue: QueueIcon,
  assignment: AssignmentIcon,
  eventNote: EventNoteIcon,
  groups: GroupsIcon,
  monetization: MonetizationOnIcon,
  trending: TrendingUpIcon,
  feedback: FeedbackIcon,
  videocam: VideocamIcon,
  autoStories: AutoStoriesIcon,
  science: ScienceIcon,
  email: EmailOutlinedIcon,
  schedule: ScheduleIcon,
  users: UsersIcon,
};

export function getNavIcon(name, fontSize = 'small') {
  const Icon = ICONS[name];
  if (!Icon) return null;
  return <Icon fontSize={fontSize} />;
}
